import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '30px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '30px',
    },
    //テキスト
      textField: {
        flexGrow: 1,
        height: '100%',
        width: '100%',
        border: 'none',
        backgroundColor: 'transparent',
        textAlign: "center",
    },
  })
);

export const RawWaveformComparisonConanairStyle = makeStyles(
  createStyles({
    responsiveContainer: {
      minHeight: 'calc(100vh - 434px)',
      maxHeight: 'calc(100vh - 434px)',
    },
    paper: {
      background: '#FFFFEE',
    },
  })
);

export const FooterBaseStyle = makeStyles(
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
